import AgreementCardTitle from "assets/locales/en/AgreementCardTitle.js"
import AgreementModal from "assets/locales/en/AgreementModal.js"
import ServiceAgreement from "assets/locales/en/ServiceAgreement.js"
import SorryPage from "assets/locales/en/SorryPage.js"
import TextCopyright from "assets/locales/en/TextCopyright.js"
import LanguageSwitch from "assets/locales/en/LanguageSwitch.js"

export default {
  ...AgreementCardTitle,
  ...AgreementModal,
  ...ServiceAgreement,
  ...SorryPage,
  ...TextCopyright,
  ...LanguageSwitch,
}
